import React, { useState, useEffect, Fragment, useContext } from "react";
import peij from "../../../services/peij";
import ijws from "../../../services/ijws";
import AppContext from "../../../container/context";
import { Button, CircularProgress } from "@mui/material";
import Form from "../../../components/form";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";

const Conteudo = ({ unidadeId }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [aulas, setAulas] = useState([]);
  // const [unidade, setUnidade] = useState({});

  useEffect(() => {
    carregarConteudo();
  }, [unidadeId]);

  const carregarConteudo = () => {
    if (unidadeId > 0) {
      setCarregando(true);

      ijws
        .get("admin/unidades/conteudo", { unidadeId })
        .then((videos) => {
          if (!videos || videos.length === 0) {
            return notification("error", "Não foi possível carregar as aulas");
          }

          // const unidade = {
          //   nivel: videos[0].nivelNome,
          //   numero: videos[0].unidadeNumero,
          //   titulo: videos[0].unidadeTitulo,
          // };

          const aulas = [];

          videos.forEach((v) => {
            const aulaLocalizada = aulas.filter(
              (a) => a.numero === v.aulaNumero
            );

            if (aulaLocalizada.length > 0) {
              aulaLocalizada[0].videos.push(v);
            } else {
              aulas.push({
                id: v.aulaId,
                numero: v.aulaNumero,
                videos: [v],
                unidadeId: v.unidadeId,
              });
            }
          });

          // setUnidade(unidade);
          setAulas(aulas);

          setCarregando(false);
        })
        .catch((err) => notification("error", "Erro ao carregar a unidade"));
    }
  };

  // const camposCabecalho = (unidade) => {
  //   return {
  //     nivel: {
  //       label: "Nível",
  //       type: "text",
  //       value: unidade.nivel,
  //       lineSpacing: 4,
  //       enabled: false,
  //     },
  //     numero: {
  //       label: "Número",
  //       type: "text",
  //       value: unidade.numero,
  //       lineSpacing: 4,
  //       enabled: false,
  //     },
  //     titulo: {
  //       label: "Título",
  //       type: "text",
  //       value: unidade.titulo,
  //       lineSpacing: 4,
  //       enabled: false,
  //     },
  //   };
  // };

  if (carregando)
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <CircularProgress color="info" />
      </div>
    );

  return (
    <>
      {aulas.map((aula, key) => (
        <Aula key={key} aula={aula} recarregar={carregarConteudo} />
      ))}
    </>
  );
};

const Aula = ({ aula, recarregar }) => {
  const [aulaAddVideo, setAulaAddVideo] = useState(0);

  // const formulario = (aula) => {
  //   return {
  //     numero: {
  //       label: "Número",
  //       type: "number",
  //       value: aula.numero,
  //       lineSpacing: 4,
  //     },
  //     titulo: {
  //       label: "Título",
  //       type: "text",
  //       value: aula.titulo,
  //       lineSpacing: 8,
  //     },
  //   };
  // };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div key="titulo">
          <h3 style={{ paddingTop: 15 }}>Vídeos da aula {aula.numero}</h3>
        </div>
        {aulaAddVideo === 0 && (
          <Button
            variant="contained"
            color="info"
            style={{ color: "white" }}
            onClick={() => setAulaAddVideo(aula.id)}
          >
            Adicionar vídeo
            <AddToPhotosIcon style={{ marginLeft: 5 }} />
          </Button>
        )}
      </div>
      {aulaAddVideo > 0 && (
        <Video
          key={0}
          video={{ videoId: 0 }}
          aulaId={aula.id}
          unidadeId={aula.unidadeId}
          recarregar={recarregar}
          cancelarNovoVideo={() => setAulaAddVideo(0)}
        />
      )}
      {aula.videos.map((video, key) => (
        <Video
          key={key}
          video={video}
          aulaId={aula.id}
          unidadeId={aula.unidadeId}
          recarregar={recarregar}
        />
      ))}
    </>
  );
};

const Video = ({ video, aulaId, unidadeId, recarregar, cancelarNovoVideo }) => {
  const { notification, confirm } = useContext(AppContext);

  const salvarVideo = (videoSalvar) => {
    videoSalvar.aulaId = aulaId;
    videoSalvar.categoria = 4;
    videoSalvar.unidadeId = unidadeId;

    if (video.videoId > 0) {
      videoSalvar.id = video.videoId;

      ijws
        .post("admin/videos/editar", videoSalvar)
        .then((res) => {
          notification("success", "Video salvo!");
          recarregar();
        })
        .catch((err) => {
          console.log("err", err);
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Referência inválida");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Unidade inválida");
            case 4:
              return notification("error", "Aula inválida");
            default:
              return notification("error", "Erro ao editar video");
          }
        });
    } else {
      ijws
        .post("admin/videos/inserir", videoSalvar)
        .then((res) => {
          notification("success", "Video salvo!");
          recarregar();
        })
        .catch((err) => {
          console.log("err", err);
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Referência inválida");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Unidade inválida");
            case 4:
              return notification("error", "Aula inválida");
            default:
              return notification("error", "Erro ao editar video");
          }
        });
    }
  };

  const excluirVideo = () => {
    confirm({
      title: "Deseja realmente excluir o vídeo?",
      label: "Não será possível desfazer esta ação.",
      onConfirm: () => {
        ijws
          .delete("admin/videos/remover", { id: video.videoId })
          .then((res) => {
            notification("warning", "Vídeo removido.");
            recarregar();
          })
          .catch((err) => {
            console.log("delete", err);
            notification("error", "Não foi possível remover o vídeo.");
          });
      },
    });
  };

  const fVideo = {
    title: video.videoId > 0 ? undefined : "Novo vídeo",
    form: {
      ordem: {
        label: "Ordem",
        type: "number",
        value: video.videoOrdem,
        space: 4,
      },
      titulo: {
        label: "Título",
        type: "text",
        value: video.videoTitulo,
        space: 8,
        required: true,
      },
      referencia: {
        label: "ID Youtube",
        type: "text",
        value: video.videoReferencia,
        space: 4,
      },
      identificadorAtividade: {
        label: "Identificador da atividade",
        type: "text",
        value: video.videoIdentificadorAtividade,
        space: 4,
      },
      execultar: {
        type: "component",
        value: (
          <div
            style={{ height: "100%", display: "flex", alignItems: "center" }}
          >
            {video.videoIdentificadorAtividade ? (
              <a
                href={`https://app.inglesjuntos.com.br/teste-atividade?id=${video.videoIdentificadorAtividade}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Executar
              </a>
            ) : null}
          </div>
        ),
        space: 4,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarVideo,
    },
    close:
      video.videoId === 0
        ? { label: "Cancelar", action: () => cancelarNovoVideo() }
        : false,
    customActions:
      video.videoId > 0
        ? [
            {
              warning: true,
              label: "Excluir",
              action: excluirVideo,
            },
          ]
        : undefined,
  };

  return <Form formData={fVideo} />;
};

export default Conteudo;
